(function () {
  const phone = '919885004643'; // your number, no +

  function init() {
    const btn = document.getElementById('ats-wa-float');
    if (!btn) return;

    // ✅ read product/page name from attribute (your case: "Ivana Heels")
    const titleEl = document.querySelector('[data-ats-product-title]');
    const title = (titleEl?.getAttribute('data-ats-product-title') || '').trim();

    let message = 'Hi, I want to know more about your products.';

    // product title found
    if (title) {
      message = `Hi, I want to know more about ${title}.`;
    }

    btn.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
